/*
  The "Get $5 Off" teaser (bottom-left corner) is rendered by the Emotive app inside the open shadow
  root of #emotive-popup-teaser-shadow. Its label is a plain <div> with a click handler: it cannot be
  reached with the keyboard and is not announced as a button (#548). The theme cannot change the
  app's markup, so we add the button semantics, keyboard activation and a focus ring from here.
  The app re-renders with React, so the patch is re-applied on mutation. If Emotive closes the shadow
  root or renames these elements this quietly does nothing; the real fix belongs in the Emotive
  dashboard/app, this keeps the storefront usable until then.
*/
(function () {
  var HOST_ID = 'emotive-popup-teaser-shadow';
  var STYLE_ID = 'stash-emotive-teaser-a11y';
  // White ring on the teaser's dark pill, well above 3:1.
  var CSS =
    '[data-stash-teaser-button]:focus-visible{outline:2px solid #fff;outline-offset:2px;border-radius:4px}';
  var watched = new WeakSet();

  function setAttr(el, name, value) {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }

  function popupFrame() {
    return document.getElementById('emotive-popup-ui');
  }

  // The same iframe is a small invisible box (300x150) while closed and a full-viewport modal when open.
  function isOpen(frame) {
    return frame.getBoundingClientRect().height >= window.innerHeight - 1;
  }

  // Keyboard activation only (mouse behaviour is untouched): the popup is a full-screen modal iframe, so
  // focus has to move into it, and back to the teaser when it closes. If the iframe does not show up
  // shortly, do nothing rather than steal focus.
  function activate(target) {
    target.click();

    var tries = 0;
    var wait = setInterval(function () {
      var frame = popupFrame();
      tries += 1;
      if (!frame || !isOpen(frame)) {
        if (tries > 20) clearInterval(wait);
        return;
      }
      clearInterval(wait);
      frame.focus();
      try {
        frame.contentWindow.focus();
      } catch (e) {}

      var closeWatch = new MutationObserver(function () {
        if (isOpen(frame)) return;
        closeWatch.disconnect();
        var active = document.activeElement;
        if (target.isConnected && (!active || active === document.body || active === frame)) {
          target.focus();
        }
      });
      closeWatch.observe(frame, { attributes: true, attributeFilter: ['class', 'style'] });
    }, 100);
  }

  function patch(root) {
    if (!root.getElementById || !root.getElementById(STYLE_ID)) {
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = CSS;
      root.appendChild(style);
    }

    // The label sits next to the app's own close <button>, so the button role goes on the label
    // only; wrapping both would nest interactive controls.
    var label = root.querySelector('#emotive-popup-teaser-container p');
    var target = label && label.parentElement;
    if (!target) return;

    setAttr(target, 'role', 'button');
    setAttr(target, 'tabindex', '0');
    setAttr(target, 'aria-haspopup', 'dialog');
    setAttr(target, 'data-stash-teaser-button', '');

    if (target.dataset.stashTeaserKeys) return;
    target.dataset.stashTeaserKeys = 'true';
    target.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        activate(target);
      } else if (e.key === ' ') {
        // Space activates on key release, like a native button, and must not scroll the page.
        e.preventDefault();
      }
    });
    target.addEventListener('keyup', function (e) {
      if (e.key === ' ') activate(target);
    });
  }

  function scan() {
    var host = document.getElementById(HOST_ID);
    var root = host && host.shadowRoot;
    if (!root) return;

    patch(root);
    if (watched.has(root)) return;
    watched.add(root);
    new MutationObserver(function () {
      patch(root);
    }).observe(root, { childList: true, subtree: true });
  }

  var timer = null;
  function queueScan() {
    if (timer) return;
    timer = setTimeout(function () {
      timer = null;
      scan();
    }, 100);
  }

  new MutationObserver(queueScan).observe(document.documentElement, { childList: true, subtree: true });
  scan();
})();
